var map = {
	"./bann---er.jpg": "48d0",
	"./banner-1.jpg": "5123",
	"./banner-10.jpg": "89e8",
	"./banner-11.jpg": "3e7b",
	"./banner-12.jpg": "925e",
	"./banner-2.jpg": "eff0",
	"./banner-3.jpg": "edee",
	"./banner-5.jpg": "1d76",
	"./banner-6.jpg": "0895",
	"./banner-7.jpg": "15ff",
	"./banner-8.jpg": "5613",
	"./health_needs.png": "bc5d",
	"./hero_banner.png": "31c3",
	"./side-banner.jpg": "7ebd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e506";